export const makeListadoAvisoCard = () => {
  return `margin-bottom: 16px;
    `
}
